import { render, staticRenderFns } from "./IncidentsView.vue?vue&type=template&id=278ee48f&"
import script from "./IncidentsView.vue?vue&type=script&lang=js&"
export * from "./IncidentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports